import React, { useState, useEffect } from 'react'
import validate from 'validate.js'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Button, TextField, Box } from '@material-ui/core'
import Alert from 'src/components/Alert'
import clsx from 'clsx'
import getExistingCallcenter from 'src/utils/getExistingCallcenter'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  root: {},
  formGroup: {
    marginBottom: theme.spacing(3)
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  button: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1)
  },
  alert: {
    marginBottom: theme.spacing(2)
  },
  showAlert: {
    opacity: 0
  }
}))

/* Componente di creazione di un callcenter */
function RegisterCallcenterForm ({ className, close, setCallcenterAndClose, ...rest }) {
  const classes = useStyles()

  const { t } = useTranslation('registerCallcenterForm')

  const schema = {
    name: {
      presence: { allowEmpty: false, message: t('schema.name') }
    }
  }

  const [confirmEnabled, setConfirmEnabled] = useState(true)
  const [formState, setFormState] = useState({
    registerSuccess: false,
    registerError: false,
    registerMessage: '',
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  })

  const handleChange = (event) => {
    event.persist()

    setFormState((prevFormState) => ({
      ...prevFormState,
      values: {
        ...prevFormState.values,
        [event.target.name]: event.target.value
      },
      touched: {
        ...prevFormState.touched,
        [event.target.name]: true
      }
    }))
  }

  // Funzione di submit della form
  const handleSubmit = async (event) => {
    setConfirmEnabled(false)
    event.preventDefault()
    const { values } = formState
    const { name } = values
    try {
      const callcenter = await getExistingCallcenter(name)
      setCallcenterAndClose(callcenter.uuid)
      setConfirmEnabled(false)
    } catch (e) {
      console.log(e)
      setConfirmEnabled(false)
    }
  }

  const hasError = (field) => (!!(formState.touched[field] && formState.errors[field]))

  useEffect(() => {
    const errors = validate(formState.values, schema, { fullMessages: false })

    setFormState((prevFormState) => ({
      ...prevFormState,
      isValid: !errors,
      errors: errors || {}
    }))
    // eslint-disable-next-line
  }, [formState.values])

  return (
    <>
      <Alert variant={formState.registerSuccess ? 'success' : 'default'} className={!formState.registerError && !formState.registerSuccess ? clsx(classes.alert, classes.showAlert) : classes.alert} message={formState.registerMessage} />
      <form
        {...rest}
        className={classes.root}
        onSubmit={handleSubmit}
      >
        <div className={classes.formGroup}>
          <TextField
            error={hasError('name')}
            helperText={hasError('name') ? formState.errors.name[0] : null}
            fullWidth
            label={t('fields.name')}
            name='name'
            onChange={(event) => handleChange(event)}
            values={formState.values.name || ''}
            variant='outlined'
          />
        </div>
        <Box width='100%' display='flex' justifyContent='flex-end'>
          <Button
            onClick={close}
            className={classes.button}
            color='default'
            size='large'
          >
            {t('buttons.cancel')}
          </Button>
          <Button
            className={classes.button}
            color='primary'
            disabled={!formState.isValid || !confirmEnabled}
            size='large'
            type='submit'
            variant='contained'
          >
            {t('buttons.create')}
          </Button>
        </Box>
      </form>
    </>)
}

RegisterCallcenterForm.propTypes = {
  className: PropTypes.string,
  close: PropTypes.func.isRequired
}

export default RegisterCallcenterForm
